<template>
  <div class="queue-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "queueBase",
};
</script>
